import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { FindingsAlert, FindingsSelector } from '@app/icare/components/findings'
import { PatientAnamnesisEditDrawer } from '@app/icare/entities/patient/edits/PatientAnamnesisEditDrawer'
import { selectByFindingId } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { patientQueryOptions } from '@app/icare/entities/patient/queries/patientQueryOptions'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { entityParams } from '@pkg/db/utils'
import { EditSectionButton } from '@pkg/ui/button'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button, Flex, Space } from 'antd'
import { FaCopy } from 'react-icons/fa6'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese/diagnose')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) => queryClient.ensureQueryData(patientQueryOptions(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()
  const { data } = useSuspenseQuery(patientQueryOptions(patientId))
  const diagnosis = data?.anamnesis?.diagnosis ?? []
  const additionalInfo = data?.anamnesis?.additionalInfo ?? null

  const handleCopy = async () => {
    if (diagnosis.length > 0) {
      await navigator.clipboard.writeText(diagnosis.map(d => d.value).join(', '))
    }
  }

  return (
    <Flex vertical gap="small">
      <FindingsSelector selector={selectByFindingId('AnamnesisDiagnosisRequired')}>
        {f => <FindingsAlert findings={f} />}
      </FindingsSelector>
      <ProCard
        title={<Trans>Diagnose</Trans>}
        extra={
          <Space>
            <Button icon={<FaCopy />} onClick={() => void handleCopy()}>
              <Trans>Kopieren</Trans>
            </Button>
            <EditSectionButton
              aria-label={t`Diagnose bearbeiten`}
              onClick={() => void PatientAnamnesisEditDrawer.show({ patientId })}
            />
          </Space>
        }
      >
        <ProDescriptions column={1}>
          <ProDescriptions.Item label={t`Hauptdiagnose`}>
            {diagnosis.length > 0 ? diagnosis.map(d => d.value).join(', ') : '-'}
          </ProDescriptions.Item>
          <ProDescriptions.Item label={t`Zusätzliche Informationen`}>{additionalInfo ?? '-'}</ProDescriptions.Item>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
